import { SVGProps } from 'react';

const SvgSignatureSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8l-61.2-48H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H450.1l28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM178 114.2c5.9-19.8 24.3-34.2 46-34.2 26.5 0 48 21.5 48 48v7.9c0 16.7-.9 33.4-2.6 50L178 114.2zm165.5 129.7 73.7-22.8-22.5 63-51.2-40.2zm1.7 124.1h-41.1c-7 16.3-14.8 32.4-23.3 48h125.4l-60.9-48zM158 251.1c-36.9 11.4-62 45.5-62 84.1V410c0 38.6 31.3 70 70 70 24.6 0 47.4-12.9 60-34l15.9-26.4c18.5-30.8 33.8-63.3 45.7-97l-40-31.6c-11.5 36.3-27.2 71.2-46.8 103.9l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7-12.1 0-22-9.8-22-22v-74.8c0-17.5 11.4-33 28.2-38.2l59.5-18.4-45.8-36.1-28 8.6zM64 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h40.2c-.1-2-.2-4-.2-6v-42z" />
  </svg>
);
export default SvgSignatureSlash;
